var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnfoldMore = function SvgUnfoldMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21L7.5 16.5L8.6 15.4L12 18.8L15.4 15.4L16.5 16.5L12 21ZM8.6 8.69998L7.5 7.59998L12 3.09998L16.5 7.59998L15.4 8.69998L12 5.29998L8.6 8.69998Z",
    fill: "#000000"
  })));
};
export default SvgUnfoldMore;